
import styled from "styled-components"
import Graphic from "../../assets/images/login_graphic.svg"
import { COLORS, SCREEN_SIZES } from "../../constants"
import { Row, Col } from "reactstrap"
import { CustomInput, CustomButton } from "../../components"

import { useState } from "react"
import { validateEmail } from "../../features"
import { Link } from "react-router-dom"
import ReactLoading from "react-loading"
import axios from 'axios';

const StyledCol = styled(Col)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledRow = styled(Row)`
    padding: 50px;
    @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
        padding: 20px 0;
    }
`;
const StyledHeader = styled.h5`
  color: ${COLORS.text_green};
`;
const StyledLabel = styled.div`
  text-align: start;
  color: ${COLORS.text_grey};
`;
const StyledPig = styled.img`
   width: 250px;
   @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
       width: 200px;
    }
`;
const StyledSideGreen = styled.img`
  position: absolute;
  height: 70%;
  left: 0;
  bottom: 0;
  z-index: 0;

  @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
      display: none;
    }
`;
const StyledForm = styled.form`
    width: 80%;
    @media only screen and (max-width: ${SCREEN_SIZES.sm}) {
      width: 100%;
      padding: 20px;
    }
`;
export function ResendVerify(props) {
    const api = process.env.REACT_APP_API_URL;
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState('');
    const [messageShown, setMessageShown] = useState('')

    const resend = async () => {
        setLoading(true)
        setMessageShown('')
        if (validateEmail(email)) {

            try {
                const response = await axios.post(`${api}/pt/initiate_email_verification`, { email: email })
                const data = response.data;
                setLoading(false)
                if (data.status_code == -101) {
                    setMessageShown(data.message)
                } else {
                    setSuccess(true)
                }
            } catch (error) {
                setLoading(false)
                setMessageShown("Server error encountered. Try to reload a page or contact support.")
            }

        } else {
            setMessageShown("Check your email")
            setLoading(false)
        }

    }
    return (
        <>
            <StyledRow className="m-0 h-100 d-flex justify-content-center">
                <StyledSideGreen src={Graphic} />

                <StyledCol lg={8}>
                    {success ? <div><StyledHeader>Email Verification</StyledHeader><div>Email verification email arrives typically in 5 minutes. Don't forget to check your spam folder.</div>

                    </div>
                        :
                        <div style={{ width: "80%" }}>
                            <StyledHeader>Resend Email Verification</StyledHeader>
                            <StyledLabel className="mt-3">Your Email</StyledLabel>
                            <CustomInput type="email" className="w-100" value={email} onChange={(e) => setEmail(e.target.value)} />
                            <CustomButton
                                style={{ width: 200, marginTop: 10, width: "100%" }}
                                color={COLORS.text_dark_green}
                                bgColor={COLORS.green}
                                className="mb-2"
                                hover={COLORS.text_green}
                                onClick={resend}
                            >
                                {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Send'}
                            </CustomButton>
                            <Link to="/" style={{ color: COLORS.text_grey }}>Go to Log In</Link>
                            <div className="mt-2" style={{ color: "red" }}>{messageShown}</div>
                        </div>
                    }

                </StyledCol>
            </StyledRow>
        </>
    );
}


